export default __webpack_public_path__ + "static/media/vangi_powder.2336ec12.png";